import { useNavigate } from 'react-router-dom';
import { IoChevronBack, IoClose } from 'react-icons/io5';
import Styles from './header.module.css';

type Props = {
  title: string;
  /** 'back': 履歴を1つ戻る / 'close': 診断トップへ */
  mode?: 'back' | 'close';
};

const PersonalityHeader: React.FC<Props> = ({ title, mode = 'back' }) => {
  const navigate = useNavigate();

  const onAction = () => {
    if (mode === 'close') {
      navigate('/personality');
      return;
    }
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/personality');
    }
  };

  return (
    <div className={Styles.header}>
      <button type="button" className={Styles.iconButton} onClick={onAction} aria-label={mode === 'close' ? '閉じる' : '戻る'}>
        {mode === 'close' ? <IoClose size={20} /> : <IoChevronBack size={20} />}
      </button>
      <p className={Styles.title}>{title}</p>
    </div>
  );
};

export default PersonalityHeader;
